import React from "react";

const DropdownValue = ({ value, handleClick }) => {
  return (
    <div className="dropdown__content">
      <div
        className="dropdown__content__value"
        onClick={(event) => {
          event.stopPropagation();
          handleClick();
        }}
      >
        {value}
      </div>
    </div>
  );
};

export default DropdownValue;
